import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { openDB, deleteDB } from 'idb'

if (environment.production) {
  enableProdMode();
}

if(iOS()){
  document.getElementById("my-manifest").setAttribute("href", "manifest-ios/manifest.webmanifest")
}
else{
  document.getElementById("my-manifest").setAttribute("href", "manifest.webmanifest")
}

const dbName = 'tokenDb'
const storeName = 'token'
const version = 5;
const url = new URL(window.location.href);
const dbValue = url.searchParams.get("d");
const db =  openDB(dbName, version,{
   upgrade(db) {
    if(!db.objectStoreNames.contains(storeName)) {
      db.createObjectStore(storeName);
    }
  }
}).then(async (res) => {
  const transaction = res.transaction(storeName, 'readwrite');
  const store = transaction.objectStore(storeName);
  if(dbValue) {
    await store.put(dbValue , 'param');
  }
  transaction.done;
});

function iOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
